export const classes = {
  card: 'place-center flex-col p-0 h-40 cursor-pointer bg-gradient-to-br transition-all text-grey-8 dark:text-mauve-1 shadow-none',
  empty:
    'from-grey-1/20 from-[50%] to-grey-4/30 dark:bg-none dark:bg-white/[0.03] border-2 border-dashed border-grey-4 dark:border-white/10 hover:bg-grey-1 dark:hover:bg-white/[0.07]',
  filled:
    'bg-grey-1 dark:bg-none dark:bg-white/[0.06] hover:bg-grey-2 dark:hover:bg-white/[0.1] from-blue-1/20 from-[50%] to-blue-2/30 border-2 border-blue-3',
  input: 'hidden',
};

export const styles = {
  card: {
    '&:hover .upload-icon-wrapper': {
      padding: '1rem',
    },
  },
};
